module.exports = __webpack_public_path__ + "img/both.047a20af.png";